export const COOKIE_BANNER_TEXT = {
  description:
    'We use first- and third-party cookies and similar technologies for enhancing your experience, personalization, analytics, advertising, and improving our site. By continuing to browse our site, you agree to the',
  termsOfUse: 'Terms of Use',
  privacyNotice: 'Privacy Notice',
  optOut: 'To manage your settings and to opt out of non-necessary cookies, click ',
  cookieManagement: 'Cookie management',
  punctuation: '.',
}
